import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_38_95_1W_6_93',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_38_95_1w_6_93_usd',
			AUD: 'simple_premium_4w_59_99_1w_10_99_aud',
			BRL: 'simple_premium_4w_219_1w_38_99_brl',
			CAD: 'simple_premium_4w_49_99_1w_9_99_cad',
			DKK: 'simple_premium_4w_259_1w_39_99_dkk',
			EUR: 'simple_premium_4w_38_95_1w_6_93_eur',
			GBP: 'simple_premium_4w_38_95_1w_6_93_gbp',
			MXN: 'simple_premium_4w_749_1w_129_99_mxn',
			NOK: 'simple_premium_4w_389_1w_69_99_nok',
			SEK: 'simple_premium_4w_369_1w_65_99_sek',
			TRY: 'simple_premium_4w_1519_1w_269_try',
			ARS: 'simple_premium_4w_51890_1w_9290_ars',
			COP: 'simple_premium_4w_157390_1w_27990_cop',
			CLP: 'simple_premium_4w_37690_1w_6790_clp',
		},
		primer: 'prd_x2E1ay0Bxgg0',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 6.93,
			AUD: 10.99,
			BRL: 38.99,
			CAD: 9.99,
			DKK: 39.99,
			EUR: 6.93,
			GBP: 6.93,
			MXN: 129.99,
			NOK: 69.99,
			PLN: 25.99,
			SEK: 65.99,
			TRY: 269,
			ARS: 9290,
			COP: 27990,
			CLP: 6790,
		},
		originalPriceMap: {
			USD: 17.77,
			AUD: 28.18,
			BRL: 99.97,
			CAD: 25.62,
			DKK: 102.53,
			EUR: 17.77,
			GBP: 17.77,
			MXN: 333.31,
			NOK: 179.46,
			PLN: 66.64,
			SEK: 169.2,
			TRY: 689.74,
			ARS: 27770,
			COP: 77700,
			CLP: 17770,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			AUD: 59.99,
			BRL: 219,
			CAD: 49.99,
			DKK: 259,
			EUR: 38.95,
			GBP: 38.95,
			MXN: 749,
			NOK: 389,
			PLN: 139.99,
			SEK: 369,
			TRY: 1519,
			ARS: 51890,
			COP: 157390,
			CLP: 37690,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: '7-days', // 'first week'
		explicitTermsIntervalText: $t('common.week_plural', 4), // '4 weeks',
		billingSubtitlePeriodText: $tc('common.duration.week.first', 1), // 'first week'
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 1), // '1-week'
		footerIntervalText: $tc('common.duration.week.dashed.lowercase', 4), // '4-week',
		updatedTermsPeriodText: $tc('common.duration.week.first', 1), // 'first week'
	}),
}
